export function getParaStudentDisplayName(studentRow: any | null | undefined): string {
	const s = studentRow;
	const first = s?.student?.firstName != null ? String(s.student.firstName).trim() : '';
	const last = s?.student?.lastName != null ? String(s.student.lastName).trim() : '';
	const full = `${first} ${last}`.trim();
	if (full) return full;

	const alt = s?.name != null ? String(s.name).trim() : '';
	return alt || 'Student';
}

export function getParaStudentDisplayGrade(studentRow: any | null | undefined): string {
	const s = studentRow;
	const g = s?.grade ?? s?.student?.grade ?? null;
	return g != null ? String(g).trim() : '';
}

